import { Done } from "@mui/icons-material";

interface Props {
  icon?: any;
  text: string;
  subtitle?: string;
}

export default function Feedback(props: Props) {
  const { text, subtitle } = props;

  return (
    <div className="w-full rounded-xl bg-white px-4 py-6">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="mb-6 flex h-[76px] w-[76px] items-center justify-center rounded-full bg-primaryLight">
          <Done fontSize="medium" className="text-primary" aria-hidden="true" />
        </div>

        <p className="text-pretty text-2xl font-semibold text-primary">{text}</p>
        {subtitle && (
          <p className="mt-3 text-base leading-relaxed text-muted">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
